import { render, staticRenderFns } from "./PpvFilterPanelHeader.vue?vue&type=template&id=f3dfc066&scoped=true"
import script from "./PpvFilterPanelHeader.vue?vue&type=script&lang=js"
export * from "./PpvFilterPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./PpvFilterPanelHeader.vue?vue&type=style&index=0&id=f3dfc066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dfc066",
  null
  
)

export default component.exports